"use strict";

exports.__esModule = true;
exports.alignTo = alignTo;
/**
 * Align a given numeric value to an increment size.
 */
function alignTo(value, size) {
  return Math.round(value / size) * size;
}